import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LoadingSlipsListPage = lazy(() => import("@/pages/loading-slips.index.page"));

export const Route = createFileRoute("/loading-slips/")({
  component: LoadingSlipsListPage,
});
